// Generated file - do not edit
import atlasUrl from './icon-atlas.png'

export const iconAtlas = atlasUrl
export const iconMapping = {
  circle: {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    anchorX: 16,
    anchorY: 16,
    mask: true
  }
} as const
